
import {  useState } from "react";
import { useMediaQuery } from 'react-responsive';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboard, faGear } from '@fortawesome/free-solid-svg-icons';
import {  Link } from "react-router-dom";

export default function HeadPage() {
const [query, setQuery] = useState("");
  // Responsive to mobile or dekstop
  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 780px)'});


  return (
    <div >

      {/* <div className="body-header d-flex">
        {isTabletOrMobile ? 
          <>
            <div className="title-page">
              <h6><FontAwesomeIcon icon={faListUl}/> Penilaian</h6>
            </div> 
            
            <div className="ml-auto">
                <button  className="btn btn-create"> <Link  to="/dimensi-configs" style={{color: "#fff", textDecoration: "none"}}><FontAwesomeIcon icon={faGear} /> Konfigurasi Nilai</Link> </button>
            </div>
          </>
          : 
          <>
            <div className="title-page">
              <h5><FontAwesomeIcon icon={faListUl}/> Penilaian </h5>
            </div>
            
            <div className="ml-auto">
                <button  className="btn btn-create"> <Link style={{color: "#fff", textDecoration: "none"}}  to="/dimensi-configs"><FontAwesomeIcon icon={faGear} /> Konfigurasi Nilai</Link> </button>
            </div>
          </>
        }   
      </div>  */}

      <div className="page-header-card">
         {isTabletOrMobile ? (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faClipboard} />
                  </span>
                <h4 className="page-title-text"> Penilaian</h4>
              </div>
            </div>
            <div className="ml-auto">
                <button
                  className="btn btn-create"
                  style={{
                    borderRadius: 12,
                    padding: "8px 14px",
                    boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                  }}
                >
                  <Link style={{color: "#fff", textDecoration: "none"}}  to="/element-recaps-dimensi/dimensi-configs">
                  <FontAwesomeIcon icon={faGear} /> 
                  Konfigurasi Nilai</Link> 
                </button>
            </div>

            

             <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-main">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Penilaian
                </li>
              </ol>
            </nav>
          </>
          ) : (
          <>
            <div className="page-header-top d-flex">
              <div className="page-title-wrap">
                <span className="page-title-icon">
                  <FontAwesomeIcon icon={faClipboard} />
                </span>
                <h4 className="page-title-text"> Penilaian</h4>
              </div>

              <div className="ml-auto">
                <Link style={{color: "#fff", textDecoration: "none"}}  to="/element-recaps-dimensi/dimensi-configs">
                <button
                  className="btn btn-create"
                  style={{
                    borderRadius: 12,
                    padding: "8px 14px",
                    boxShadow: "0 10px 24px rgba(108,99,255,0.18)",
                  }}
                >
                  
                  <FontAwesomeIcon icon={faGear} /> 
                  Konfigurasi Nilai
                </button>
</Link> 
                {/* <button  className="btn btn-create"> 
                  <Link style={{color: "#fff", textDecoration: "none"}}  to="/dimensi-configs">
                  <FontAwesomeIcon icon={faGear} /> 
                  Konfigurasi Nilai</Link> 
                  </button> */}
              </div>
            </div>



            <nav aria-label="breadcrumb" className="custom-breadcrumb-nav mt-4">
              <ol className="custom-breadcrumb">
                <li className="custom-breadcrumb-item">
                  <Link to="/dashboards-main">Beranda</Link>
                </li>
                <li className="custom-breadcrumb-separator">/</li>
                <li
                  className="custom-breadcrumb-item active"
                  aria-current="page"
                >
                  Penilaian
                </li>
              </ol>
            </nav>
          </>
         )}
      </div>

  </div>
  );
}
